import { CancellationToken } from "Global/Base/Promises/CancellationTokenSource";

/**
 * Parametry předávané do všech CRUD volání serveru.
 * @includeToDoc
 */
export type RequestContext = {
    readonly roles?: readonly string[];

    /** Verze nastavení práv, které se má použít pro request. */
    readonly rightsSettingsVersion?: string;

    //readonly transationContextId?: string;
    getTransactionContextId?: () => string | undefined;

    /** Umožňuje stornovat běžící dotaz */
    readonly cancellationToken: CancellationToken;
};

/**
 * Vrací request kontext sestávající pouze se zadaného `cancellationToken`.
 * Určeno pro situace, kdy se záměrně role ani ID transakčního kontextu nepředává.
 */
export const getCancellationTokenAsRequestContext = (cancellationToken: CancellationToken): RequestContext => ({
    roles: undefined,
    getTransactionContextId: () => undefined,
    cancellationToken,
});

/**
 * Request kontext bez rolí, bez transakčního kontextu a bez tokenu k přerušení operace.
 */
export const EMPTY_REQUEST_CONTEXT: RequestContext = {
    roles: undefined,
    getTransactionContextId: () => undefined,
    cancellationToken: CancellationToken.none,
};
